import React, { useState } from 'react';
import { ButtonBase, Typography, CircularProgress, Box } from '@mui/material';
import { logger } from '../../../utils/logger';

const OrderButton = ({ handleOrderNow, clickOrder }: { handleOrderNow: () => void; clickOrder: boolean }) => {

  const handleOrderMode = async () => {
    try {
      await handleOrderNow();
    } catch (error) {
      logger.error("Error handling order:", error);
    } 
  };

  return (
    <Box
        sx={{
        position: 'relative',
        width: '54.0rem',
        height: '5.5rem',
        }}
    >
        <ButtonBase
        sx={{
            backgroundColor: '#DA291C',
            textTransform: 'none',
            borderRadius: '15rem',
            width: '100%',
            height: '100%',
            pointerEvents: clickOrder ? 'none' : 'auto',
        }}
        onClick={handleOrderMode}
        disabled={clickOrder}
        >
        {!clickOrder && (
            <Typography
            sx={{
                fontSize: '2.4rem',
                fontWeight: '600',
                color: '#fff',
                padding: '.7rem .4rem',
            }}
            >
            Order Now
            </Typography>
        )}
        </ButtonBase>
        {clickOrder && (
        <Box
            sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: clickOrder? '#999':'#DA291C',
            borderRadius: '5.0rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            }}
        >
            <CircularProgress
            size={24}
            style={{
                color: '#fff',
            }}
            />
        </Box>
        )}
    </Box>
  );
};

export default OrderButton;